/**
 * 视频元数据错误码枚举
 */
export enum VideoMetadataErrorCode {
  /** 无法获取视频尺寸 */
  METADATA_DIMENSIONS_FAILED = 'METADATA_DIMENSIONS_FAILED',
  /** 获取视频元数据超时 */
  METADATA_TIMEOUT = 'METADATA_TIMEOUT',
  /** 视频加载失败 */
  METADATA_LOAD_FAILED = 'METADATA_LOAD_FAILED',
  /** 获取视频元数据失败（通用） */
  METADATA_FAILED = 'METADATA_FAILED',
}

/**
 * 视频元数据错误类
 * 用于统一处理视频元数据获取过程中的错误
 */
export class VideoMetadataError extends Error {
  public readonly code: VideoMetadataErrorCode;
  public readonly originalMessage?: string;

  constructor(code: VideoMetadataErrorCode, message: string, originalMessage?: string) {
    super(message);
    this.name = 'VideoMetadataError';
    this.code = code;
    this.originalMessage = originalMessage;
  }
}

/**
 * 判断是否为视频元数据错误
 */
const isVideoMetadataError = (error: unknown): error is VideoMetadataError => {
  return error instanceof VideoMetadataError || (error instanceof Error && error.name === 'VideoMetadataError');
};

/**
 * 从错误中提取错误码
 * @param error - 错误对象
 * @returns 错误码，如果不是 VideoMetadataError 则返回 undefined
 */
export const getVideoMetadataErrorCode = (error: unknown): VideoMetadataErrorCode | undefined => {
  if (isVideoMetadataError(error)) {
    return error.code;
  }
  return undefined;
};
